import React, { useEffect, useRef } from 'react'
import Prism from 'prismjs'
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace'
import 'prismjs/plugins/toolbar/prism-toolbar'
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-ini'
import 'prismjs/components/prism-apacheconf'
import 'prismjs/components/prism-nginx'
import 'prismjs/components/prism-yaml'

type Props = {
    html?: string | null
}

/**
 * Renders a server-rendered (Twig + markdown) description as HTML and applies
 * Prism syntax highlighting to fenced code blocks inside it.
 */
export const ServerRenderedDescription: React.FunctionComponent<Props> = ({ html }) => {
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const container = containerRef.current
        if (container === null) {
            return
        }

        // Only highlight fenced code blocks (`<pre> > <code>`), never inline `<code>`.
        // Inline code carries no language, so Prism would tag it `language-none`, which the
        // okaidia theme paints with a dark background pill. Restricting to `pre > code` keeps
        // inline code on the default light styling. This mirrors the React `CodeBlock`
        // component, which likewise only ever highlights code wrapped in `<pre>`.
        const codeBlocks = container.querySelectorAll('pre > code')
        codeBlocks.forEach(codeBlock => Prism.highlightElement(codeBlock))
    }, [html])

    if (!html) {
        return null
    }

    return <div ref={containerRef} className="server-rendered-description" dangerouslySetInnerHTML={{ __html: html }} />
}
